import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function AdminJobs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/jobs").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">All jobs</h1>
      <div className="space-y-2">
        {items.map((j) => (
          <div key={j.id} className="card-tactile p-4 flex items-center justify-between gap-3 flex-wrap">
            <div>
              <div className="font-display text-lg font-bold text-slate-900">{j.title}</div>
              <div className="text-sm text-slate-600">{j.company_name} · {j.location} · {j.date}</div>
            </div>
            <div className="flex items-center gap-3">
              <div className="text-sm text-slate-700">{j.staff_booked}/{j.staff_required} booked</div>
              <StatusBadge status={j.status} />
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-500 py-10 text-center">No jobs yet.</div>}
      </div>
    </div>
  );
}
